import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden"]

  select(event) {
    event.preventDefault()
    this.hiddenTarget.value = event.currentTarget.dataset.value || ""
    this.element.closest("form").requestSubmit()
  }
}
